<template>
  <div class="flex flex-wrap">
    <div class="w-2/5">
      <div class="m-12">
        <div class="mx-auto w-3/4">
          <div class="flex items-center">
            <span class="text-gray-400 text-2xl">{{ getAppName }}</span>
            <img src="https://img.icons8.com/bubbles/50/000000/graduation-cap.png" class="mx-3" />
            <span class="text-white text-2xl font-black">Academy</span>
          </div>

          <div class="text-base text-white mt-4 pt-5 border-t border-blue-500">
            Welcome to {{ getAppName }} Academy.
          </div>

          <div class="text-base text-white mt-4">
            Here, we have compiled a list of tutorials, which will help you maximize your
            experience with {{ getAppName }}.
          </div>
        </div>
      </div>
    </div>

    <div class="w-3/5">
      <div class="m-12 flex flex-wrap">
        <div class="w-1/2 p-4">
          <router-link 
            :to="{
              name  : 'broker-onboard-first-client-intro',
              params: {
                brokerId   : $route.params.brokerId
              }
            }"
            tag="a" 
            class="block bg-white p-5 rounded-lg shadow-lg">

            <img src="https://img.icons8.com/clouds/100/000000/user.png" class="w-16" />

            <div class="mt-4 text-xl font-thin">
              1. Adding your very first client
            </div>

            <div class="text-sm mt-4 text-gray-800">
              Adding a client is probably the most common task you will do on {{ getAppName }}.
              Let us show you how simple &amp; easy it is. <br/><br/>
            </div>

            <div class="text-sm mt-6 flex items-center">
              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#clock"/>
              </svg>

              <span class="ml-2 mr-6 text-gray-600">3 minutes</span>

              <!-- <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#briefcase"/>
              </svg>

              <span class="ml-2 text-gray-600">Beginner</span> -->
            </div>
          </router-link>
        </div>


        <div class="w-1/2 p-4">
          <router-link 
            :to="{
              name  : 'broker-onboard-personalize-intro',
              params: {
                brokerId   : $route.params.brokerId
              }
            }"
            tag="a" 
            class="block bg-white p-5 rounded-lg shadow-lg">


            <img src="https://img.icons8.com/clouds/100/000000/macbook-settings.png" class="w-16" />

            <div class="mt-4 text-xl font-thin">
              2. Personalize my {{ getAppName }}
            </div>

            <div class="text-sm mt-4 text-gray-800">
              {{ getAppName }} lets you personalize your account with your logo, profile image, colours 
              and videos, building trust and credibility for your clients.
            </div>

            <div class="text-sm mt-6 flex items-center">
              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#clock"/>
              </svg>

              <span class="ml-2 mr-6 text-gray-600">5 minutes</span>

              <!-- <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#briefcase"/>
              </svg>

              <span class="ml-2 text-gray-600">Beginner</span> -->
            </div>
          </router-link>
        </div>

        <div class="w-1/2 p-4">
          <!-- <router-link 
            :to="{
              name  : 'broker-onboard-mail-intro',
              params: {
                brokerId: $route.params.brokerId
              }
            }"
            tag="a" 
            class="block bg-white p-5 rounded-lg shadow-lg"> -->

          <div class="bg-white p-5 rounded-lg shadow-lg">
            <img src="https://img.icons8.com/clouds/100/000000/important-mail.png" class="w-16" />

            <div class="mt-4 text-xl font-thin">
              3. Configure Mail Settings
            </div>

            <div class="text-sm mt-4 text-gray-800">
              Before sending out the application form to your clients as an email, 
              personalize the email subject, message &amp; attachments to get the best replies.
            </div>

            <div class="text-sm mt-6 flex items-center">
              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#clock"/>
              </svg>

              <span class="ml-2 mr-6 text-gray-600">3 minutes</span>

              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#briefcase"/>
              </svg>

              <span class="ml-2 text-red-600">Coming soon</span>
            </div>
          </div>
          <!-- </router-link> -->
        </div>

        <div class="w-1/2 p-4">
          <!-- <router-link 
            :to="{
              name  : 'broker-onboard-mail-intro',
              params: {
                brokerId: $route.params.brokerId
              }
            }"
            tag="a" 
            class="block bg-white p-5 rounded-lg shadow-lg"> -->

          <div class="bg-white p-5 rounded-lg shadow-lg">
            <img src="https://img.icons8.com/clouds/100/000000/folder-invoices.png" class="w-16" />

            <div class="mt-4 text-xl font-thin">
              4. Templates Part 1 - Assets &amp; Liabilities
            </div>

            <div class="text-sm mt-4 text-gray-800">
              Master the templates for Assets and Liabilities and which will accelerate your productivity
              and scale your business almost immediately.
            </div>

            <div class="text-sm mt-6 flex items-center">
              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#clock"/>
              </svg>

              <span class="ml-2 mr-6 text-gray-600">3 minutes</span>

              <svg width="16" height="16" stroke-width="2" class="text-gray-500 " stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#briefcase"/>
              </svg>

              <span class="ml-2 text-red-600">Coming soon</span>
            </div>
          </div>
          <!-- </router-link> -->
        </div>
      </div>
    </div>

    <!-- 

    <div class="flex flex-wrap -mx-4 mt-12">
      

      <div class="w-1/3 px-4">

      </div>

      <div class="w-1/3 px-4">
        <a href="#" class="block bg-white p-5 rounded-lg shadow-lg">
          <div class="text-center">
            <img src="https://img.icons8.com/clouds/100/000000/folder-bills.png" class="inline" />
          </div>

          <div class="text-center mt-4 text-xl font-thin">
            Using Templates to Scale Up!
          </div>

          <div class="text-base mt-6 text-gray-800">
            {{ getAppName }} lets you personalize your account with your logo, profile image, colours 
            and videos, building trust and credibility for your clients.
          </div>
        </a>
      </div>
    </div>

    <div class="flex flex-wrap -mx-4 mt-12">
      <div class="w-1/3 px-4">
        <a href="#" class="block bg-white p-5 rounded-lg shadow-lg">
          <div class="text-center">
            <img src="https://img.icons8.com/clouds/100/000000/user.png" class="inline" />
          </div>

          <div class="text-center mt-4 text-xl font-thin">
            1. Mercury Overview
          </div>

          <div class="text-base mt-6 text-gray-800">
            Learn about how {{ getAppName }} integrates with Mercury.
            If you're an existing Mercury user,...
          </div>
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2   from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2
    },

    data () {
      return {
        loading: false,
      }
    },

    mounted() {
      document.body.className = 'onboard-bg'
    },

    beforeDestroy() {
      document.body.className = ''
    },

    methods : {
      
    },
  }
</script>